
import Vue from 'vue'
import UiButton from '@/components/UiButton.vue'

export default Vue.extend({
  name: "UiModal",
  props: {
    header: String,
    confirmText: String,
    isOpen: Boolean,
    isBtnLoading: Boolean,
    onModalToggle: Function,
  },
  data(){
    return {}
  },
  computed: {},
  methods: {},
  components: {
    UiButton
  }
})
